import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  archiveLetterTemplate,
  createLetterTemplate,
  deleteLetterTemplate,
  fetchAllLetterContentTemplate,
  updateLetterTemplate,
  updateLetterTemplateStatus,
} from "app/services/transmission/letter_templates";
import { BASE_URL } from "static/constants";

export const letterTemplateApi = createApi({
  reducerPath: "letterTemplateApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["LetterTemplates", "letterContentTemplates"],
  endpoints: (builder) => ({
    createLetterTemplate: builder.mutation({
      queryFn: (payload) => {
        return createLetterTemplate(payload);
      },
      invalidatesTags: ["LetterTemplates"],
    }),
    updateLetterTemplate: builder.mutation({
      queryFn: ({ payload, templateId }) => {
        return updateLetterTemplate(payload, templateId);
      },
      invalidatesTags: ["LetterTemplates"],
    }),
    archiveLetterTemplate: builder.mutation({
      queryFn: (templateId) => {
        return archiveLetterTemplate(templateId);
      },
      invalidatesTags: ["LetterTemplates"],
    }),
    updateLetterTemplateStatus: builder.mutation({
      queryFn: ({ templateId, status }) => {
        return updateLetterTemplateStatus(templateId, status);
      },
      invalidatesTags: ["LetterTemplates"],
    }),
    deleteLetterTemplate: builder.mutation({
      queryFn: (templateId) => {
        return deleteLetterTemplate(templateId);
      },
      invalidatesTags: ["LetterTemplates"],
    }),
    fetchAllLetterContentTemplate: builder.query({
      queryFn: async () => {
        const response = await fetchAllLetterContentTemplate();
        return {
          data: response.data,
        };
      },

      providesTags: ["letterContentTemplates"],
    }),
  }),
});

export const {
  useCreateLetterTemplateMutation,
  useUpdateLetterTemplateMutation,
  useArchiveLetterTemplateMutation,
  useDeleteLetterTemplateMutation,
  useFetchAllLetterContentTemplateQuery,
  useUpdateLetterTemplateStatusMutation,
} = letterTemplateApi;
